import type { ReactElement } from 'react';
import * as React from 'react';
import { Modal, Text } from '@hotjar/hotsauce';
import personSitsOnTable from '@hotjar/shared-assets/images/person-sits-on-table.svg';
import { useEffect } from 'react';
import { viewElement } from '@hotjar/tracking';
import { Trans, useTranslationWithPrefix, useHelpHotjarUrl } from '@hotjar/translations';
import styled from '@emotion/styled';
import { CaptionLink, HighlightBox, HighlightBoxImage, MessageBody, Subtitle } from './styles';

const StyledModalBody = styled(Modal.Body)`
  padding: 24px 40px 40px 40px !important;
`;

export const EngageActivationNeededModal = ({
  isOpen,
  onClose,
  trackData,
  accountAdminName,
}: {
  isOpen: boolean;
  onClose: () => void;
  trackData: { accountId: number; orgId: number; siteId: number };
  accountAdminName?: string;
}): ReactElement => {
  const { t } = useTranslationWithPrefix('auth:engage:unauthorized-modal');
  const helpHotjarUrl = useHelpHotjarUrl();

  useEffect(() => {
    if (isOpen) {
      viewElement({
        name: 'engageActivationRequested',
        uiPosition: 'Activation Needed Modal',
        groupData: {
          account_id: trackData.accountId,
          organization_id: trackData.orgId,
          site_id: trackData.siteId,
        },
        data: {},
      });
    }
  }, [trackData, isOpen]);

  return (
    <Modal contentLabel={t('title')} isOpen={isOpen} onClose={onClose} size="m">
      <Modal.Header title={t('title')} />
      <StyledModalBody>
        <MessageBody>
          <Trans t={t} i18nKey="message" values={{ accountAdminName }}>
            <strong>{accountAdminName}</strong>
          </Trans>
        </MessageBody>
        <HighlightBox>
          <div className="text-part">
            <Subtitle>{t('box-title')}</Subtitle>
            <Text as="p" textType="caption" textColor="text_light">
              {t('box-message')}
            </Text>
            <CaptionLink
              href={`${helpHotjarUrl}/articles/10158131341463`}
              kind="standalone"
              isExternal
            >
              {t('box-link')}
            </CaptionLink>
          </div>
          <div className="image-part">
            <HighlightBoxImage src={personSitsOnTable} />
          </div>
        </HighlightBox>
      </StyledModalBody>
    </Modal>
  );
};
